const initialState = {
	profile: 0,
	profileLog: {
		comment: null,
		partnerComment: null,
	},
	photo: 0,
	proof: {
		person: 0,
		photo: 0,
		income: 0,
		single: 0,
	},
	email: null,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MY_REQUEST_SET') {
		let payload = action.payload;
		let newState = {
			profile: payload.profile,
			profileLog: {
				comment: payload.profileLog.comment,
				partnerComment: payload.profileLog.partnerComment,
			},
			photo: payload.photo,
			proof: {
				person: payload.proof.person,
				photo:  payload.proof.photo,
				income: payload.proof.income,
				single: payload.proof.single,
			},
			email: payload.email,
			datetime: (new Date()),
		}
		return newState;
	}
	else if (action.type === 'MY_REQUEST_INIT') {
		return initialState;
	}
	else {
		return state;
	}
}
